import { AddFinanceCostsForm } from "components/Forms/AddFinanceCostsForm/AddFinanceCostsForm";
import { DataItem } from "components/Tables/FinanceRevenuesTable/mock";
import { Drawer } from "components/UI/Drawer";
import { DrawerTitle } from "components/UI/DrawerTitle/DrawerTitle.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";
import { DrawerId } from "types/models.ts";

interface AddFinanceCostsDrawerProps {
    handleAdd: (newItem: DataItem) => void;
}

export const AddFinanceCostsDrawer: FC<AddFinanceCostsDrawerProps> = ({ handleAdd }) => {
    const { t } = usePaldockTranslation("drawers.add-finance-costs");
    const id = DrawerId.AddFinanceCost;

    return (
        <Drawer drawerId={id} title={<DrawerTitle mainTitle={t("title")} />}>
            <AddFinanceCostsForm handleAdd={handleAdd} />
        </Drawer>
    );
};
